import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  getToken(): Observable<string | null> {
    return from('API-TOKEN');
  }
}
